// import { TNavigationActionTypes, SET_NAVIGATION, SET_TABLE_FILTER, SET_SERVER_404, RESET_TABLE_FILTER } from "types/actions/TNaviationActionTypes"
import { CaseReducer, PayloadAction, createSlice } from "@reduxjs/toolkit"
import INavigation from "types/frontend_models/navigation/INavigation"
import { RouteId } from "types/frontend_models/navigation/RouteId"

interface INavigationState
{
  navigation: INavigation,
  notFound404: { isTrue: boolean, message: string },
  sidebarOpen: boolean
}

const initialState: INavigationState = {
  navigation: {
    activeRouteId: RouteId.home,
    topbarTitle: ''
  },
  notFound404: {
    isTrue: false,
    message: ''
  },
  sidebarOpen: true
}

/* ACTION REDUCERS */
const setNavigationReducer: CaseReducer<INavigationState, PayloadAction<{ navigation: INavigation }>> = (state, action) =>
{
  state.navigation = action.payload.navigation;
}
const setServer404Reducer: CaseReducer<INavigationState, PayloadAction<{ errorMessage: string }>> = (state, action) =>
{
  state.notFound404.isTrue = true;
  state.notFound404.message = action.payload.errorMessage;
}
const toggleSideBarReducer: CaseReducer<INavigationState> = (state) =>
{
  state.sidebarOpen = !state.sidebarOpen;
}


/* SLICE */

const navigationSlice = createSlice({
  name: "navigation",
  initialState: initialState,
  reducers: {
    setNavigation: setNavigationReducer,
    setServer404: setServer404Reducer,
    toggleSidebar: toggleSideBarReducer
  }
});

export const {
  setNavigation,
  setServer404,
  toggleSidebar
} = navigationSlice.actions;

export default navigationSlice.reducer;

/* DEPRECATED REDUCER */

// function navigationReducer(
//   state = initialState,
//   action: TNavigationActionTypes
// ): INavigationState {
//   switch (action.type) {
//     case SET_NAVIGATION:
//       return {
//         ...state,
//         navigation: action.navigation
//       }
//     case SET_TABLE_FILTER:
//       return {
//         ...state,
//         tablesAndFilters: [
//           ...state.tablesAndFilters.map(filter => {
//             if (filter.table === action.filterData.table) {
//               return {
//                 table: action.filterData.table,
//                 filters: action.filterData.filters,
//               }
//             } else {
//               return filter
//             }

//           })
//         ],
//       }
//     case RESET_TABLE_FILTER:
//       return {
//         ...state,
//         tablesAndFilters: defaultTableFilters,
//       }
//     case SET_SERVER_404:
//       return {
//         ...state,
//         notFound404: action.data
//       }
//     default:
//       return state
//   }
// }

// export default navigationReducer;